import { render, staticRenderFns } from "./ListExclusivePartners.vue?vue&type=template&id=3388bb12&"
import script from "./ListExclusivePartners.vue?vue&type=script&lang=ts&"
export * from "./ListExclusivePartners.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports